import React from 'react'
import { Text, Heading, Image, MapWidget, MapMenu, MapItem, MapLayer, MapOverlay, MessageTooltip } from 'components/library'
import { Layer } from 'components/library/widgets/map/components'
import { Slider } from 'content/components/slider/Slider'
import DropdownMix from 'content/components/dropdown/DropdownMix'
import { checkIE11 } from 'helpers'

import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'
import layer01 from './assets/maplayer_1_3_5_2-01-01.svg'
import layer1_4_1 from './assets/layer1_4_1-01.svg'
import layer1_4_1_IE from './assets/layer1_4_1-01-IE.svg'
import layer1_4_2 from './assets/layer1_4_2-01.svg'
import layer1_4_2_IE from './assets/layer1_4_2-01-IE.svg'
import layer1_4_3 from './assets/layer1_4_3-01.svg'
import layer1_4_3_IE from './assets/layer1_4_3-01-IE.svg'
import layer4_1_1 from './assets/layer4_1_1-01.svg'
import layer4_1_1_IE from './assets/layer4_1_1-01-IE.svg'
import layer4_1_2 from './assets/layer4_1_2-01.svg'
import layer4_1_2_IE from './assets/layer4_1_2-01-IE.svg'
import layer4_1_3 from './assets/layer4_1_3-01.svg'
import layer4_1_3_IE from './assets/layer4_1_3-01-IE.svg'

/* Tab 03 */
import img01 from './assets/10@3x.svg'
import img02 from './assets/6@3x.svg'
import img03 from './assets/img03.svg'

/* Tab 04 */
import img04 from './assets/4@3x.svg'
import img05 from './assets/9@3x.svg'

import './C02A03Tab03.css'

const svgLayers = {
  '1-4-1': checkIE11() ? layer1_4_1_IE : layer1_4_1_IE,
  '1-4-2': checkIE11() ? layer1_4_2_IE : layer1_4_1,
  '1-4-3': checkIE11() ? layer1_4_3_IE : layer1_4_2,
  '4-1-1': checkIE11() ? layer4_1_1_IE : layer4_1_1,
  '4-1-2': checkIE11() ? layer4_1_2_IE : layer4_1_2,
  '4-1-3': checkIE11() ? layer4_1_3_IE : layer4_1_3,
}

class C02A03Tab03 extends React.Component {
  state = {
    dropdownValue: [1,4],
    sliderValue: 0,
  }

  handleDropdownChange = value => {
    this.setState({
      dropdownValue: value,
      sliderValue: 0,
    })
  }

  handleSliderChange = value => {
    this.setState({ sliderValue: value })
  }

  checkValues = values => {
    return values.join(',') === this.state.dropdownValue.join(',')
  }

  render() {
    return (
      <div className="C02A03Tab03">
        <MapWidget
          mapImage={mapBaseImage}
          height={740}
          mapBounds={[[0, 0], [3556, 3406]]}
          options={{ minZoom: -1.5 }}
          liftStateTab={this.props.liftStateTab}
          liftStateDropdownValues={this.liftStateDropdownValues}>

          <MapMenu>
            <MapItem center={[836,2045]} zoom={-1.2} label={'Voorwaarden'}>
              <MapOverlay>
                <MessageTooltip>
                  <Text>Als je zonder sleepobject van Schiphol-Oost naar Schiphol-Centrum of andersom moet rijden, kan Apron Control je de opdracht geven via de Zuidelijke trekkerroute te rijden. Het is ook mogelijk deze route zelf aan te vragen bij Apron Control. Je mag alleen van de Zuidelijke trekkerroute gebruik maken als je voldoet aan de voorwaarden:</Text>
                  <ul>
                    <li>Je vliegtuigtrekker is maximaal 3.80 meter breed.</li>
                    <li>Er is geen sprake van BZO.</li>
                    <li>De route is open voor sleeptrekkers (er wordt geen onderhoud gepleegd).</li>
                    <li>Je bent bekend met de routering  en hebt de Read en Understood procedure van je interne afhandelaar ondertekend. Deze procedure houdt in dat jij tijdelijke en permanente wijzigingen hebt gelezen en begrepen.</li>
                  </ul>
                  <Text><strong>Let op!</strong> Het is jouw verantwoordelijkheid om na te gaan of je bevoegd bent om gebruik te maken van de Zuidelijke trekkerroute</Text>
                </MessageTooltip>
              </MapOverlay>
              <MapLayer>
                <Layer url={layer01} bounds={[[0, 0], [3556, 3406]]} />
              </MapLayer>
            </MapItem>

            <MapItem label={'Klaringregels'}>
              <MapOverlay>
                <DropdownMix
                  value={this.state.dropdownValue}
                  options={[
                    { value: 1, label: 'Schiphol-Oost' },
                    { value: 4, label: 'Schiphol-Centrum' },
                  ]} onChange={this.handleDropdownChange} />

                <br />

                {this.checkValues([1,4]) &&
                  <Slider onChange={this.handleSliderChange}>
                    <div>
                      <Text><strong>Stap 1</strong></Text>
                      <Text>Je vraagt vanaf je vertrekpunt klaring aan voor het gebruik van de Zuidelijke trekkerroute. Als je bent aangekomen op de Oostelijke dienstweg 36R, ter hoogte van  hangar 73, dien je Rijbaan Golf vrij te melden.</Text>
                    </div>
                    <div>
                      <Text><strong>Stap 2</strong></Text>
                      <Text>Na het verlaten van de Zuidelijke dienstweg 06, ter hoogte van VOP S96, dien je de Zuidelijke trekkerroute vrij te melden.</Text>
                    </div>
                    <div>
                      <Text><strong>Stap 3</strong></Text>
                      <Text>Indien je eindbestemming verder ligt dan VOP S96, zal je vanaf VOP S96 zelfstandig via de randwegen naar je eindbestemming moeten rijden.</Text>
                    </div>
                  </Slider>
                }

                {this.checkValues([4,1]) &&
                  <Slider onChange={this.handleSliderChange}>
                    <div>
                      <Text><strong>Stap 1</strong></Text>
                      <Text>Als je van Schiphol-Centrum naar Schiphol-Oost wil, rijdt je zelfstandig via de randwegen naar het beginpunt van de Zuidelijke trekkerroute.</Text>
                    </div>
                    <div>
                      <Text><strong>Stap 2</strong></Text>
                      <Text>Bij VOP S96 die je bij Apron-Zuid klaring aan te vragen voor de Zuidelijke trekkerroute. <strong>Let
                        op!</strong> er is een mogelijkheid om van tevoren bij Apron-Zuid te checken of de Zuidelijke trekkerroute beschikbaar is.</Text>
                    </div>
                    <div>
                      <Text><strong>Stap 3</strong></Text>
                      <Text>Als je bestemming hangar 73 is, dien je je af te melden bij het meldpunt op de Oostelijke dienstweg 36R, ter hoogte van  hangar 73. Indien je bestemming verder op Schiphol-Oost ligt, dien je klaring aan te vragen voor Rijbaan G.</Text>
                    </div>
                  </Slider>
                }
              </MapOverlay>

              <MapLayer>
                {this.checkValues([1,4]) && this.state.sliderValue === 0 &&
                  <Layer
                    url={svgLayers['1-4-1']}
                    bounds={[[0, 0], [3556, 3406]]}
                    center={[1075,1884]}
                    zoom={-1.2} />
                }

                {this.checkValues([1,4]) && this.state.sliderValue === 1 &&
                  <Layer
                    url={svgLayers['1-4-2']}
                    bounds={[[0, 0], [3556, 3406]]}
                    center={[1075,1884]}
                    zoom={-1.2} />
                }

                {this.checkValues([1,4]) && this.state.sliderValue === 2 &&
                  <Layer
                    url={svgLayers['1-4-3']}
                    bounds={[[0, 0], [3556, 3406]]}
                    center={[1075,1884]}
                    zoom={-1.2} />
                }

                {this.checkValues([4,1]) && this.state.sliderValue === 0 &&
                  <Layer
                    url={svgLayers['4-1-1']}
                    bounds={[[0, 0], [3556, 3406]]}
                    center={[1075,1884]}
                    zoom={-1.2} />
                }

                {this.checkValues([4,1]) && this.state.sliderValue === 1 &&
                  <Layer
                    url={svgLayers['4-1-2']}
                    bounds={[[0, 0], [3556, 3406]]}
                    center={[1075,1884]}
                    zoom={-1.2} />
                }

                {this.checkValues([4,1]) && this.state.sliderValue === 2 &&
                  <Layer
                    url={svgLayers['4-1-3']}
                    bounds={[[0, 0], [3556, 3406]]}
                    center={[1075,1884]}
                    zoom={-1.2} />
                }
              </MapLayer>
            </MapItem>

            <MapItem label={'Extra Attentie'}>
              <MapOverlay>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img03} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Heading h3>Verlichting</Heading>
                    <Text>Om je te kunnen onderscheiden van andere voertuigen dien je een zwaailicht te voeren.</Text>
                  </div>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img01} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Heading h3>Uitluisterplicht</Heading>
                    <Text>Je wordt op de Zuidelijke trekkerroute niet actief begeleid door Apron Control. Er geldt daarom een uitluisterplicht.</Text>
                  </div>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img02} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Heading h3>BZO</Heading>
                    <Text>Indien er een BZO fase wordt afgekondigd terwijl jij je op de Zuideijke trekkerroute bevindt, dien je de route uit te rijden.</Text>
                  </div>
                </div>
              </MapOverlay>
            </MapItem>

            <MapItem label={'Voorrangsregels'}>
              <MapOverlay>
                <div className="is-row">
                  <Text><strong>Naast de standaardvoorrangsregels die op Airside gelden, zijn er een aantal aanvullende voorrangregels als je op de Zuidelijke trekkerroute rijdt.</strong></Text>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img04} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Text>Overige voertuigen dienen jou voorrang te verlenen door gebruik te maken van de passeerstroken.</Text>
                  </div>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img05} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Text>Indien jij en een andere vliegtuigtrekker elkaar tegemoet komen, dan dient de vliegtuigtrekker met de passeerstrook aan de rechterzijde gebruik te maken van deze passeerstrook, om de andere vliegtuigtrekker te laten passeren.</Text>
                  </div>
                </div>
              </MapOverlay>
            </MapItem>
          </MapMenu>
        </MapWidget>
      </div>
    )
  }
}

export default C02A03Tab03



// WEBPACK FOOTER //
// ./src/content/chapters/02/03/components/c02_a03_tab_03/C02A03Tab03.js